import { render, staticRenderFns } from "./PageFamilyOwnerAdd.vue?vue&type=template&id=5f0ab837&scoped=true&"
import script from "./PageFamilyOwnerAdd.vue?vue&type=script&lang=js&"
export * from "./PageFamilyOwnerAdd.vue?vue&type=script&lang=js&"
import style0 from "./PageFamilyOwnerAdd.vue?vue&type=style&index=0&id=5f0ab837&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0ab837",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VForm,VTextField})
